import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { COUNTRIES_AUTO_COMPLETE_REQUEST, COUNTRIES_AUTO_COMPLETE_SUCCESSFUL, COUNTRIES_AUTO_COMPLETE_FAILURE } from 'action-creators/countriesAutocomplete';
import { RESET } from 'action-creators/generic';
import { CountryAutoComplete } from 'models/countryAutoComplete';

export interface CountriesAutoCompleteState {
  isLoading: boolean;
  bySearch: CountryAutoComplete[];
  error: string | null;
}

const initialState: CountriesAutoCompleteState = {
  isLoading: false,
  bySearch: [],
  error: null,
};

const reducer: Reducer<CountriesAutoCompleteState> = (state = initialState, action) => {
  switch (action.type) {
    case COUNTRIES_AUTO_COMPLETE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case COUNTRIES_AUTO_COMPLETE_SUCCESSFUL:
      return {
        ...state,
        bySearch: action.payload,
        isLoading: false,
      };
    case COUNTRIES_AUTO_COMPLETE_FAILURE:
      return {
        ...state,
        error: action.payload,
        bySearch: [],
        isLoading: false,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'countriesAutoComplete',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
